// product accordion js 

const headers = document.querySelectorAll(".accordion-header");

headers.forEach(header => {
  header.addEventListener("click", () => {

    const item = header.parentElement;

    // close all other accordions
    document.querySelectorAll(".accordion-item").forEach(el => {
      if (el !== item) {
        el.classList.remove("active");
        el.querySelector(".accordion-content").classList.add("hidden");
      }
    });

    // toggle current accordion
    const content = item.querySelector(".accordion-content");
    item.classList.toggle("active");
    content.classList.toggle("hidden");

  });
});
document.addEventListener("DOMContentLoaded", function(){

    jQuery('.js-select2').select2({
        placeholder: 'Select an option',
        minimumResultsForSearch: Infinity,
        width: '100%'
    });

});

// animation js 

 const reveals = document.querySelectorAll(".reveal");

    function revealOnScroll() {

      const windowHeight = window.innerHeight;

      reveals.forEach((element) => {

        const elementTop = element.getBoundingClientRect().top;

        const revealPoint = 120;

        if (elementTop < windowHeight - revealPoint) {
          element.classList.add("active");
        }

      });
    }

    window.addEventListener("scroll", revealOnScroll);

    window.addEventListener("load", revealOnScroll);


    // order form for ritual
document.addEventListener("DOMContentLoaded", function () {
    const orderId = new URLSearchParams(window.location.search).get("orderid");

    if (!orderId) return;

    const interval = setInterval(function () {
        const field = document.querySelector(".order_id input");

        if (field) {
            field.value = orderId;
            field.readOnly = true;
            clearInterval(interval);
        }
    }, 200);
});

